import {connect} from "react-redux"
import {IncomingHttpHeaders} from "http"
import State from "../../ducks/state"
import {
    openDrawer,
    closeCountrySelector,
    getCountriesListThunk,
    selectLanguage,
    setDefaultCountryCode,
    redirectToAlternativeLanguageThunk,
    requestCountryChange,
} from "../../ducks/country-selector"
import {TERRITORY_HEADER, LANGUAGE_HEADER} from "../../config/constants"
import {formatCdnPath} from "../../utils/getCdnUrl"
import {getBaseSiteUrl} from "../../utils/getBaseSiteUrl"
import redirectPage from "../../utils/redirectPage"
import PublishCountrySelectorClosed from "../../events/countrySelectorClosed"
import {PublishToModalsClosed} from "../../events/modalsClosed"
import urls from "../../config/urls"
import {deleteRecentQueries} from "../../ducks/recents/index"

const getIconUrl = (area: string) => formatCdnPath(`/icons/shared/countryflags/${area.toLowerCase()}.png`)

const {countrySelectUrl} = urls.countryLangSelector

export const mapStateToProps = (state: State) => {
    const territory = (state.request?.headers as IncomingHttpHeaders)[TERRITORY_HEADER] as string
    const language = (state.request?.headers as IncomingHttpHeaders)[LANGUAGE_HEADER] as string
    const text = state.text.countryLangSelector
    const {textAlignment} = state
    const {siteUrl, isInternationalCountry} = state.request
    const {itemCount} = state.shoppingBag

    const ROWLinkUrl = getBaseSiteUrl(siteUrl, territory, language) + countrySelectUrl

    const {
        isOpenCountrySelectorDrawer,
        isEnableCountrySelectorDrawer,
        isEnableCountrySelectorButton,
        selectedLanguage,
        selectedCountry,
        isShowOverlay,
        isLoaded,
    } = state.countrySelector

    return {
        isOpenCountrySelectorDrawer,
        isEnableCountrySelectorDrawer,
        iconUrl: getIconUrl(territory),
        isEnableCountrySelectorButton,
        isShowOverlay,
        textAlignment,
        territory: territory.toUpperCase(),
        language,
        selectedLanguage,
        selectedCountry,
        isInternationalCountry,
        isLoaded,
        itemCount,
        ROWLinkUrl,
        text,
        templating: state.template,
    }
}

const shopNowOnClick = (itemCount: number) => {
    return (dispatch, getState: () => State) => {
        const state = getState()
        const territory = (state.request?.headers as IncomingHttpHeaders)[TERRITORY_HEADER] as string
        const language = (state.request?.headers as IncomingHttpHeaders)[LANGUAGE_HEADER] as string
        const {selectedLanguage, selectedCountry} = state.countrySelector
        if (selectedCountry?.CountryCode.toLowerCase() === territory.toLowerCase()) {
            if (selectedLanguage !== language) {
                return redirectPage(selectedCountry, selectedLanguage)
            }
            PublishCountrySelectorClosed()
            return dispatch(closeCountrySelector())
        }
        if (itemCount > 0) {
            dispatch(closeCountrySelector())
            dispatch(requestCountryChange(true))
        } else {
            return redirectPage(selectedCountry, selectedLanguage)
        }
    }
}

export const mapDispatchToProps = dispatch => ({
    closePanel: () => {
        PublishCountrySelectorClosed()
        return dispatch(closeCountrySelector())
    },
    openDrawer: (isShowOverlay: boolean) => {
        PublishToModalsClosed()
        return dispatch(openDrawer(isShowOverlay))
    },
    selectDefaultCountry: (countryCode: string) => dispatch(setDefaultCountryCode(countryCode)),
    selectLanguage: (language: string) => dispatch(selectLanguage(language)),
    deleteRecentQueries: () => {
        dispatch(deleteRecentQueries())
    },
    shopNowOnClick: (itemCount: number) => dispatch(shopNowOnClick(itemCount)),
    getCountriesListThunk: () => dispatch(getCountriesListThunk()),
    redirectPageToAlternativeLanguage: () => dispatch(redirectToAlternativeLanguageThunk()),
})

export default connect(mapStateToProps, mapDispatchToProps)
